'use client'

import { serializeJsonLd } from 'lib/jsonLd'
import React, { FC, useState, useLayoutEffect } from 'react'
import { TitleH2, SubText } from 'components/Common/Typography'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { FAQConstant } from 'constants/FAQConstant'
import { usePageSlug } from 'hooks/useRouteInfo'

const FaqSection: FC<{ data }> = ({ data }) => {
  const [activeId, setActiveId] = useState('0')
  const toggleActive = (id) => setActiveId(id)

  const pageSlug = usePageSlug()

  const IsFAQ =
    FAQConstant[
      pageSlug
    ]

  const [expanded, setExpanded] = useState(false)
  const dataForDisplay = expanded ? IsFAQ : IsFAQ?.slice(0, 3)
  let schemaDataFAQ = {}
  if (dataForDisplay) {
    schemaDataFAQ = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: dataForDisplay.map(({ title, description }) => ({
        '@type': 'Question',
        name: title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: description,
        },
      })),
    }
  }

  return dataForDisplay ? (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(schemaDataFAQ) }}
      />
      <section className="faq_section">
        <Container>
          <Row className="justify-content-center">
            <Col xl={8} className="text-center">
              <TitleH2 className="mb-4 text_black" text={data?.title} />
              {data?.subTitle ? (
                <SubText
                  className="pt-0 pt-lg-0 mb-4 mb-lg-5"
                  text={data?.subTitle}
                />
              ) : (
                ''
              )}
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="mt-3 justify-content-center">
            <Col xl={9} className="">
              <Accordion defaultActiveKey={activeId}>
                {dataForDisplay?.map((faq) => (
                  <Accordion.Item
                    key={faq.id}
                    eventKey={faq.id}
                    className={activeId === faq.id ? 'active' : ''}
                  >
                    <Accordion.Header onClick={() => toggleActive(faq.id)}>
                      {faq.title}
                    </Accordion.Header>
                    <Accordion.Body>{faq.description}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
            <Col xl={12} className="mt-3 mt-lg-5 pt-3 mb-0 text-center">
              <a
                className="showmore_link cursor-pointer"
                onClick={() => setExpanded(!expanded)}
                role="button"
                tabIndex={0}
              >
                {expanded ? '- Show Less' : '+ Show More'}
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  ) : null
}

export default FaqSection
